import React from 'react'

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  isAddressed?: boolean
  isRequired: boolean
}

function Icon(props: Props): JSX.Element {
  const { isRequired } = props
  // isAddressed is accepted but not currently used in the component

  function getClassNames() {
    const isRequiredClass = isRequired ? 'required' : ''
    return `condition-status ${isRequiredClass}`
  }

  return (
    <div className={ getClassNames() }/>
  )
}

export default Icon
